import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from 'react';

import axios from 'axios';

import { ICardapioContextData, ICategoryCardapio } from './interfaces';
import ImageHardcoded1 from 'components/Pages/MenuRestaurant/Assets/1.svg';
import ImageHardcoded2 from 'components/Pages/MenuRestaurant/Assets/2.png';
import ImageHardcoded3 from 'components/Pages/MenuRestaurant/Assets/3.png';
import ImageHardcoded4 from 'components/Pages/MenuRestaurant/Assets/4.png';
import ImageHardcoded5 from 'components/Pages/MenuRestaurant/Assets/5.png';
import ImageHardcoded6 from 'components/Pages/MenuRestaurant/Assets/6.png';

const CardapioContext = createContext<ICardapioContextData>(
  {} as ICardapioContextData,
);

const CardapioContextProvider: React.FC = ({ children }) => {
  const productData = [
    {
      id: 'hdasiudhasiudhasuhd',
      sku: 0,
      name: 'Balde Teste 1',
      description: 'teste testado produto',
      image: ImageHardcoded1,
      combo: 1,
      labels: ['12 pedaços ou 16 filés', 'suave', 'vibrante'],
    },
    {
      id: 'gfsdgmldfgldfmg',
      sku: 0,
      name: 'Produto Teste 2',
      description: 'teste testado produto 2',
      image: ImageHardcoded2,
      combo: 1,
      labels: ['12 pedaços ou 16 filés', 'suave', 'vibrante'],
    },
    {
      id: 'fdfdggggggggg',
      sku: 0,
      name: 'Produto Teste 3',
      description: 'teste testado produto 3',
      image: ImageHardcoded3,
      combo: 1,
      labels: ['12 pedaços ou 16 filés', 'suave', 'vibrante'],
    },
    {
      id: 'dhsaudhasudhasduha',
      sku: 0,
      name: 'Produto Teste 4',
      description: 'teste testado produto 4',
      image: ImageHardcoded4,
      combo: 1,
      labels: ['12 pedaços ou 16 filés', 'suave', 'vibrante'],
    },
    {
      id: 'dhsaudhasudhasduha',
      sku: 0,
      name: 'Produto Teste 5',
      description: 'teste testado produto 5',
      image: ImageHardcoded5,
      combo: 1,
      labels: ['12 pedaços ou 16 filés', 'suave', 'vibrante'],
    },
  ];

  const productData1 = [
    {
      id: 'hdasiudhasiudhasuhd',
      sku: 0,
      name: 'Balde Teste 1',
      description: 'teste testado produto',
      image: ImageHardcoded1,
      combo: 1,
      labels: ['12 pedaços ou 16 filés', 'suave', 'vibrante'],
    },
    {
      id: 'gfsdgmldfgldfmg',
      sku: 0,
      name: 'Produto Teste 2',
      description: 'teste testado produto 2',
      image: ImageHardcoded2,
      combo: 1,
      labels: ['12 pedaços ou 16 filés', 'suave', 'vibrante'],
    },
    {
      id: 'fdfdggggggggg',
      sku: 0,
      name: 'Produto Teste 3',
      description: 'teste testado produto 3',
      image: ImageHardcoded3,
      combo: 1,
      labels: ['12 pedaços ou 16 filés', 'suave', 'vibrante'],
    },
    {
      id: 'dhsaudhasudhasduha',
      sku: 0,
      name: 'Produto Teste 4',
      description: 'teste testado produto 4',
      image: ImageHardcoded4,
      combo: 1,
      labels: ['12 pedaços ou 16 filés', 'suave', 'vibrante'],
    },
  ];

  const productData2 = [
    {
      id: 'hdasiudhasiudhasuhd',
      sku: 0,
      name: 'Balde Teste 1',
      description: 'teste testado produto',
      image: ImageHardcoded1,
      combo: 1,
      labels: ['12 pedaços ou 16 filés', 'suave', 'vibrante'],
    },
    {
      id: 'gfsdgmldfgldfmg',
      sku: 0,
      name: 'Produto Teste 2',
      description: 'teste testado produto 2',
      image: ImageHardcoded2,
      combo: 1,
      labels: ['12 pedaços ou 16 filés', 'suave', 'vibrante'],
    },
    {
      id: 'fdfdggggggggg',
      sku: 0,
      name: 'Produto Teste 3',
      description: 'teste testado produto 3',
      image: ImageHardcoded3,
      combo: 1,
      labels: ['12 pedaços ou 16 filés', 'suave', 'vibrante'],
    },
  ];

  const categoriesData = [
    {
      id: 0,
      name: 'Balde',
      image_url:
        'https://s3.amazonaws.com/media.appbk.burgerking.com.br/v3/a27f951785713eef17e0a70b62bf53a63e5e3ceded1d2a77bf64601450447364.png',
      display_order: 0,
      color: 'red',
      parent_category: 0,
      skus: productData2,
    },
    {
      id: 1,
      name: 'Saduiches',
      image_url:
        'https://s3.amazonaws.com/media.appbk.burgerking.com.br/v3/a27f951785713eef17e0a70b62bf53a63e5e3ceded1d2a77bf64601450447364.png',
      display_order: 0,
      color: 'blue',
      parent_category: 0,
      skus: productData1,
    },
    {
      id: 3,
      name: 'teste',
      image_url:
        'https://s3.amazonaws.com/media.appbk.burgerking.com.br/v3/a27f951785713eef17e0a70b62bf53a63e5e3ceded1d2a77bf64601450447364.png',
      display_order: 0,
      color: 'red',
      parent_category: 0,
      skus: productData,
    },
  ];

  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState<ICategoryCardapio[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<number>();
  const [selectedStore, setselectedStore] = useState(() => {
    const storeStorage = localStorage.getItem('@Popeyes.storeSelected');
    const storeData = JSON.parse(storeStorage);
    return storeData;
  });

  const loadCardapio = useCallback(async () => {
    setLoading(true);

    try {
      const { data } = await axios.get(
        'https://plk-microservice-store-cardapio-ummgmx7irq-ue.a.run.app/category',
      );

      setCategory(data);
      setSelectedCategoryId(data[0].id);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }, []);

  const loadCardapioFiltered = useCallback(async (idStore: number) => {
    setLoading(true);

    const idStoreString = `00${idStore}`;

    try {
      const { data } = await axios.get(
        `https://plk-microservice-store-cardapio-ummgmx7irq-ue.a.run.app/category/bk_number/${idStoreString}`,
      );

      setCategory(data);
      setSelectedCategoryId(data[0].id);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }, []);

  const handleSelectCategory = (idSelected: number) => {
    const categoryItem = category.find(category => category.id === idSelected);
    setSelectedCategoryId(categoryItem.id);
  };

  const setPositionCategory = () => {
    // chamar a função no onClick do botão q redireciona para cardapio
    const params = new URL(window.location as any).searchParams;
    const storeId = Number(params.get('loja'));

    let acumulatorPositionScroll = 200;

    if (storeId) acumulatorPositionScroll = 170;

    const newCategories: ICategoryCardapio[] = [];
    category.forEach(categoryItem => {
      categoryItem.positionCategoryContainer = acumulatorPositionScroll;

      newCategories.push(categoryItem);
      acumulatorPositionScroll += document.getElementById(
        categoryItem.name,
      ).clientHeight;
    });

    setCategory(newCategories);
  };

  const setStoreSelected = async (idStore: number, nameStore: string) => {
    setLoading(true);
    const store = {
      id: idStore,
      name: nameStore,
    };

    setselectedStore(store);
    localStorage.setItem('@Popeyes.storeSelected', JSON.stringify(store));

    await loadCardapioFiltered(idStore);

    setLoading(false);
  };

  const findStoreById = async (storeId: number) => {
    setLoading(true);

    try {
      const { data } = await axios.get(
        `https://plk-microservice-store-ummgmx7irq-ue.a.run.app/store/${storeId}`,
      );

      await setStoreSelected(data.id, data.name);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedStore) {
      loadCardapioFiltered(selectedStore.id);
    } else {
      loadCardapio();
    }
  }, []);

  return (
    <CardapioContext.Provider
      value={{
        category,
        loading,
        selectedStore,
        handleSelectCategory,
        setStoreSelected,
        setPositionCategory,
        loadCardapio,
        selectedCategoryId,
        findStoreById,
      }}
    >
      {children}
    </CardapioContext.Provider>
  );
};

function useCardapioContext(): ICardapioContextData {
  const context = useContext(CardapioContext);

  if (!context)
    throw new Error(
      'useCardapioContext must be used with CardapioContextProvider',
    );

  return context;
}

export { CardapioContextProvider, useCardapioContext };
